<template>
  <section style="min-height: 336px">
    <div class="search-panel-inner">
      <product-dropdown-mobile class="bg-white relative" v-model="searchType" />

      <free-text-search
        class="mt-4 relative"
        ref="fts"
        v-model="entry.title"
        @confirmed="handleConfirmed"
        :search-type="searchType"
      />

      <date-picker-mobile
        v-if="isShowingDates"
        class="mt-4"
        v-model="dates"
        :search-type="searchType"
      />

      <guest-picker v-if="isShowingGuests" class="mt-4" v-model="guests" />

      <button
        class="btn btn-primary w-full flex justify-center items-center mt-4"
        @click="handleCTA"
        :disabled="isWorking"
      >
        <svg width="24" height="24" class="mr-2 fill-white">
          <use xlink:href="/img/sprite.svg#ic_search-solid" />
        </svg>
        Search
      </button>
    </div>
  </section>
</template>

<script>
import ProductDropdownMobile from "./2021/ProductDropdownMobile";
import FreeTextSearch from "./2021/FreeTextSearch";
import DatePickerMobile from "./2021/DatePickerMobile";
import GuestPicker from "./2021/GuestPicker";
import WidgetMixin from "./2021/WidgetMixin";

export default {
  mixins: [WidgetMixin],
  components: {
    ProductDropdownMobile,
    FreeTextSearch,
    DatePickerMobile,
    GuestPicker,
  },
  data() {
    return {
      searchType: "resort",
      entry: {
        title: "",
      },
      dates: [],
      guests: "0",
      isDismissable: true,
      isWorking: false,
    };
  },
  computed: {
    isShowingDates() {
      return this.searchType !== "ecoventure";
    },
    isShowingGuests() {
      return this.searchType !== "ecoventure";
    },
  },
};
</script>

<style scoped>
.search-panel-inner {
  background-color: #c1c1c196;
  padding: 1rem;
}

.search-panel-inner ::v-deep .search-input {
  height: 48px;
  line-height: 48px;
  border-radius: 0;
}

.search-panel-inner ::v-deep .featured-search-wrapper {
  column-count: 1;
}
</style>
